import { useOutletContext } from "react-router-dom"

import type { Powerline } from "types/powerlines.types"

import { powerlineInfoTabPlotDefs } from "helpers/config/dashboards"
import PowerlineDashboard from "widgets/powerlines/PowerlineDashboard"
import { BodyContainer } from "widgets/styled/containers"

const PowerlineInfo = () => {
  const { powerline, powerlineFetching } = useOutletContext<{
    powerline: Powerline
    powerlineFetching: boolean
  }>()

  const config = {
    type: "powerlineInfoTab",
    plotDefs: powerlineInfoTabPlotDefs,
  }

  return (
    <BodyContainer disableGutters maxWidth="xl">
      <PowerlineDashboard
        powerline={powerline}
        powerlineFetching={powerlineFetching}
        config={config}
      />
    </BodyContainer>
  )
}

export default PowerlineInfo
